import {
  FETCH_TASK,
  FETCH_TASK_FAILURE,
  FETCH_TASK_SUCCESS,
  TOGGLE_TASK_MODAL,
} from "./constants";

export const fetchTask = (payload, onSuccess) => ({
  type: FETCH_TASK,
  payload,
  onSuccess,
});
export const fetchTaskSuccess = (payload) => ({
  type: FETCH_TASK_SUCCESS,
  payload,
});
export const fetchTaskFailure = (payload) => ({
  type: FETCH_TASK_FAILURE,
  payload,
});

export const toggleTaskModal = (payload) => ({
  type: TOGGLE_TASK_MODAL,
  payload,
});
